import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  IconButton,
} from '@mui/material';
import { Save as SaveIcon, Cancel as CancelIcon, Close as CloseIcon } from '@mui/icons-material';

const SaveProgressDialog = ({ open, onSave, onCancel, onDismiss, projectName, saving, changesTracker = [] }) => {
  const changeLabels = changesTracker.map((c) => c.label).filter(Boolean);
  const hasChangeList = changeLabels.length > 0;

  return (
    <Dialog
      open={open}
      onClose={saving ? undefined : onDismiss}
      aria-labelledby="save-progress-dialog-title"
      aria-describedby="save-progress-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="save-progress-dialog-title" sx={{ pr: 6 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SaveIcon color="primary" />
          <Typography variant="h6" component="span">
            Save Your Progress?
          </Typography>
        </Box>
        <IconButton
          aria-label="Close and go back to your work"
          title="Close and go back to your work"
          onClick={onDismiss}
          disabled={saving}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="save-progress-dialog-description">
          {projectName ? (
            <>
              You have unsaved changes for <strong>{projectName}</strong>.
            </>
          ) : (
            'You have unsaved changes.'
          )}
          {hasChangeList && (
            <>
              <br />
              <Typography component="span" variant="body2" sx={{ mt: 1, display: 'block' }}>
                Changes: {changeLabels.join(', ')}
              </Typography>
            </>
          )}
          <br />
          <br />
          Save your changes before moving to another step?
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onCancel}
          color="inherit"
          startIcon={<CancelIcon />}
          sx={{ textTransform: 'none' }}
          disabled={saving}
        >
          Don't Save
        </Button>
        <Button
          onClick={onSave}
          variant="contained"
          color="primary"
          startIcon={saving ? <CircularProgress size={18} color="inherit" /> : <SaveIcon />}
          sx={{
            backgroundColor: '#000000',
            '&:hover': {
              backgroundColor: '#333333',
            },
            textTransform: 'none',
          }}
          disabled={saving}
          autoFocus
        >
          {saving ? 'Saving...' : 'Save changes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveProgressDialog;
